<template>
  <v-container
      fluid
  >
    <v-row>
      <v-col cols="12" sm="12" md="12" class="px-0">
        <v-card class="pa-5" tile>
          <v-data-table
            class="clickable"
            :headers="headers"
            :loading="loading"
            :items="items"
            :options.sync="options"
            :server-items-length="totalItems"
            :no-results-text="$t('No matching data found')"
            :no-data-text="$t('No data available')"
            :footer-props="{'items-per-page-options': [10, 20, 50, -1]}"
            @click:row="showDialog"
          >
            <template v-slot:top>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    :label="$t('Search')"
                    single-line
                    hide-details
                    clearable
                    class="ml-3"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="text-right">
                  <v-btn
                    @click="showDialog"
                    color="secondary"
                    class="mr-3"
                    bottom
                  >
                    <v-icon left>mdi-plus</v-icon> {{ $t('Add item') }}
                  </v-btn>
                </v-col>
              </v-row>
            </template>
          </v-data-table>

          <ItemDialog ref="itemDialog" @update="fetchItems" :masterFileTypeTag="this.masterFileTypeTag"/>

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiService from '@/services/api.service'
import SessionService from '@/services/session.service'
import ItemDialog from '@/components/MasterFileDialog'
import _ from 'lodash'

export default {
  props: [
	'masterFileTypeTag'
  ],
  components: {
    ItemDialog,
  },
  data: () => ({
    items: [],
    totalItems: 10,
    loading: true,
    options: {
        itemsPerPage: 10,
    },
    search: '',

    masterFileTypes: [],
  }),
  computed: {
    masterFileType() {
        return this.masterFileTypes.find(masterFileType => masterFileType.system_tag == this.masterFileTypeTag)
    },
    headers() {
      return [ { text: this.$t('Value'), value: 'value', align: 'left', sortable: true, width: '100%' } ]
    },
  },
  watch: {
    options: {
      handler () {
        this.fetchItems()
      },
      deep: true
    },
    '$i18n.locale': function () {
      this.fetchItems()
    },
    search() {
      this.fetchItems()
    },
    masterFileTypeTag() {
      this.restoreFilters()
    },
    masterFileType(value) {
      this.$store.dispatch('session/title', this.$t('Master files') + ' - ' + this.$t(value.display_name_plural || ''))
    },
  },
  methods: {
    showDialog(item = null) {
      this.$refs.itemDialog.showDialog(item ? item.id : null, this.masterFileType)
    },
    fetchItems: _.debounce(function() {
      this.loading = true
      this.saveFilters()
      ApiService.index('/master-files', this.options, {
        params: {
          filter: {
            query: this.search,
            master_file_type_tag: this.masterFileTypeTag,
          },
        },
      }).then(({ items, total })  => {
        this.items = items
        this.totalItems = total
        this.loading = false
      }).catch(() => {
        this.loading = 'error'
      })
    }, 250),
    saveFilters() {
      SessionService.setItem('filter_master_files-' + this.masterFileTypeTag, {
        search: this.search,
        options: this.options,
      })
    },
    restoreFilters() {
      let filters = SessionService.getItem('filter_master_files-' + this.masterFileTypeTag)
      if (filters) {
        this.search = filters.search
        this.options = filters.options
      } else {
        // Initial values for when masterFileTypeTag was changed
        this.search = ''
        this.options = {
            itemsPerPage: 10,
            sortBy: '',
        }
        this.saveFilters()
      }
    },
  },
  created() {
    return ApiService.index("master-file-types")
        .then(data => {
            this.masterFileTypes = data
            return Promise.resolve()
        })
        .catch((error) => {
            console.log(error)
            return Promise.reject("Couldn't fetch master file types")
        })
  }
}
</script>

<style scoped>

</style>

